(() => {
  if (window.__uniConsultationV6) return;
  window.__uniConsultationV6 = true;
  const instances = new WeakMap();
  function initialize(root = document) {
    root.querySelectorAll('[data-uni-contact][data-mode="institutional"][data-purpose="admissions"]').forEach((section) => {
      if (instances.has(section)) return;
      const form = section.querySelector('[data-uni-contact-form]');
      if (!form) return;
      const controller = new AbortController();
      const { signal } = controller;
      const dialog = section.querySelector('[data-consultation-dialog]');
      const panel = section.querySelector('[data-consultation-form-panel]');
      const mount = dialog?.querySelector('[data-consultation-mount]');
      let placeholder;
      let opener;
      let scrollY = 0;
      let reason = 'close';
      let bodyState;
      let closingAnimation = null;
      const restore = () => {
        if (!placeholder) return;
        placeholder.replaceWith(panel);
        placeholder = null;
        document.body.classList.remove('uni-consultation-open');
        Object.entries(bodyState || {}).forEach(([key, value]) => { document.body.style[key] = value; });
        window.scrollTo({ top: scrollY, behavior: 'instant' });
        if (reason === 'submit') form.scrollIntoView({ block: 'center', behavior: 'instant' });
        else if (opener?.isConnected) opener.focus({ preventScroll: true });
      };
      if (dialog && panel && mount && typeof dialog.showModal === 'function' && section.dataset.contextualConsultation === 'true') {
        const close = () => {
          if (closingAnimation || !dialog.open) return;
          reason = 'close';
          const finish = () => { closingAnimation = null; dialog.close(); restore(); };
          const motion = !matchMedia('(prefers-reduced-motion: reduce)').matches && document.body.dataset.motion !== 'none' && (!window.UniMotion?.allowed || window.UniMotion.allowed(dialog));
          if (!dialog.classList.contains('uni-consultation-panel--compact') || !motion || !dialog.animate) { finish(); return; }
          closingAnimation = dialog.animate([{ opacity: 1, transform: 'translate(0)' }, { opacity: 0, transform: matchMedia('(max-width:600px)').matches ? 'translateY(16px)' : 'translateX(12px)' }], { duration: 180, easing: 'ease-in', fill: 'forwards' });
          closingAnimation.finished.then(finish, () => undefined);
        };
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-program-cta]');
          if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || dialog.open || form.dataset.contactState === 'confirmed') return;
          let target;
          try { target = new URL(trigger.href, location.href); } catch { return; }
          if (target.origin !== location.origin || target.pathname !== location.pathname || target.hash !== `#${section.id}`) return;
          if (document.querySelector('dialog[open]')) return;
          const program = trigger.closest('[data-program-name]');
          if (program?.dataset.programId && section.dataset.programId && program.dataset.programId !== section.dataset.programId) return;
          dialog.getAnimations().forEach(animation => animation.cancel());
          opener = trigger;
          scrollY = window.scrollY;
          reason = 'close';
          placeholder = document.createElement('div');
          placeholder.className = 'uni-consultation-placeholder';
          placeholder.setAttribute('aria-hidden', 'true');
          placeholder.style.minHeight = `${panel.getBoundingClientRect().height}px`;
          panel.before(placeholder);
          mount.appendChild(panel);
          bodyState = Object.fromEntries(['position', 'top', 'width', 'overflow'].map((key) => [key, document.body.style[key]]));
          document.body.classList.add('uni-consultation-open');
          document.body.style.position = 'fixed';
          document.body.style.top = `-${scrollY}px`;
          document.body.style.width = '100%';
          document.body.style.overflow = 'hidden';
          try { dialog.showModal(); } catch { restore(); return; }
          event.preventDefault();
          dialog.querySelector('[data-consultation-heading]')?.focus({ preventScroll: true });
        }, { signal });
        dialog.querySelector('[data-consultation-close]')?.addEventListener('click', close, { signal });
        let backdropDown = false;
        dialog.addEventListener('pointerdown', (event) => {
          const bounds = dialog.getBoundingClientRect();
          backdropDown = event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
        }, { signal });
        dialog.addEventListener('click', (event) => { if (event.target === dialog && backdropDown) close(); backdropDown = false; }, { signal });
        dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, { signal });
        dialog.addEventListener('close', restore, { signal });
        form.addEventListener('submit', () => {
          if (dialog.open && form.checkValidity() && !form.elements.namedItem('company_website')?.value) {
            reason = 'submit';
            dialog.close();
            restore();
          }
        }, { signal, capture: true });
      }
      instances.set(section, () => { closingAnimation?.cancel(); dialog?.close(); restore(); controller.abort(); instances.delete(section); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-uni-contact]').forEach((section) => instances.get(section)?.()));
})();
